module.exports = __webpack_public_path__ + "static/media/arrow_back.3c629475.svg";